"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadType = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const upload_type_constants_1 = require("./upload-type.constants");
const upload_type_styles_1 = require("./upload-type.styles");
const UploadType = (_a) => {
    var { type, className } = _a, props = __rest(_a, ["type", "className"]);
    return (react_1.default.createElement(upload_type_styles_1.StyledChip, Object.assign(Object.assign({}, props), { className: (0, classnames_1.default)(className, {
            'upload-type--manual': type === upload_type_constants_1.CatalogUploadType.Manual,
            'upload-type--automatic': type === upload_type_constants_1.CatalogUploadType.Automatic,
        }) })));
};
exports.UploadType = UploadType;
exports.default = exports.UploadType;
